import {Button, Result} from 'antd';
import {Spacer} from 'components/Spacer';
import {Stack} from 'components/Stack';
import React from 'react';
import {FallbackProps} from 'react-error-boundary';
import {config} from 'stage.config';
import {Typography} from 'antd';

const {Paragraph} = Typography;

export const ErrorView: React.FC<FallbackProps> = ({error, resetErrorBoundary}) => {
  return (
    <Result
      status="error"
      title="Oops! Something went wrong!"
      subTitle="Our developers already working to fix this."
      extra={
        <Stack>
          <Spacer />
          <Button href={`mailto:${config.supportEmail}`}>Contact us</Button>
          <Button onClick={resetErrorBoundary}>Reload</Button>
          <Spacer />
        </Stack>
      }>
      <Paragraph type="danger" strong>
        {error.message}
      </Paragraph>
      <Paragraph type="danger">{error.stack}</Paragraph>
    </Result>
  );
};
